var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require('uuid'),
  uuidV4 = _require.v4,
  uuidV5 = _require.v5;
const _require2 = require('@truqc/content-path'),
  keysSortedByValueAscending = _require2.keysSortedByValueAscending;
const _require3 = require('@truqc/walk-tree'),
  walkTree = _require3.walkTree;
const flattenCollection = collection => {
  if (collection === null || collection === undefined) {
    return undefined;
  }
  const result = [];
  const flattenCollectionInternal = (internalCollection, ancestors) => {
    keysSortedByValueAscending(internalCollection).forEach(key => {
      const item = internalCollection[key];
      const flattened = _objectSpread({
        identifier: key
      }, item);
      delete flattened.children;
      const pedigree = ancestors.slice();
      pedigree.push(flattened);
      if (item.children === undefined) {
        result.push(pedigree);
      } else {
        flattenCollectionInternal(item.children, pedigree);
      }
    });
  };
  flattenCollectionInternal(collection, []);
  return result;
};

// `v2` from `uuid` fails on iOS simulator (no crypto.getRandomValues)
const uuid = () => {
  /* eslint-disable arrow-body-style, no-plusplus */
  if (global.crypto === undefined) {
    return 'xx-x-x-x-xxx'.replace(/x/g, () => {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    });
  }
  return uuidV4().toUpperCase();
};
const renamePathFragment = (object, oldPath, newPath) => {
  const renameHandler = nodeIn => {
    const node = nodeIn;
    if (typeof node === 'object' && node[oldPath] !== undefined) {
      node[newPath] = JSON.parse(JSON.stringify(node[oldPath]));
      delete node[oldPath];
    }
  };
  walkTree(object, renameHandler);
};
const setPathFragment = (object, path, value) => {
  const setHandler = nodeIn => {
    const node = nodeIn;
    if (typeof node === 'object' && node[path] !== undefined) {
      if (value === null) {
        delete node[path];
      } else {
        node[path] = value;
      }
    }
  };
  walkTree(object, setHandler);
};
const itemDefined = item => item !== null && item !== undefined;
const itemTitle = item => item.title;
const leafTitle = items => items.length ? items[items.length - 1].title : undefined;
const pedigreeTitle = items => {
  if (leafTitle(items) === undefined) {
    return undefined;
  }
  return items.map(itemTitle).filter(itemDefined).join(': ');
};
const leafPedigreesString = collection => {
  const flattened = flattenCollection(collection);
  if (flattened === undefined) {
    return undefined;
  }
  return flattened.map(pedigreeTitle).filter(itemDefined).join(', ');
};
const leafTitlesString = collection => {
  const flattened = flattenCollection(collection);
  if (flattened === undefined) {
    return undefined;
  }
  return flattened.map(leafTitle).filter(itemDefined).join(', ');
};
module.exports = {
  flattenCollection,
  leafPedigreesString,
  leafTitlesString,
  uuid,
  uuidV5,
  renamePathFragment,
  setPathFragment
};